import { render, staticRenderFns } from "./serieslist.vue?vue&type=template&id=0f8afb24&scoped=true&"
import script from "./serieslist.vue?vue&type=script&lang=js&"
export * from "./serieslist.vue?vue&type=script&lang=js&"
import style0 from "./serieslist.vue?vue&type=style&index=0&id=0f8afb24&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8afb24",
  null
  
)

export default component.exports